import React from 'react';

import Icon from './Icon';

export default ({ cups, quantities, onChange, onClick }) => (
  <div className="slider">
    <div className="slider--detail">
      <div className="slider--detail-list">
        {Array.from(Array(quantities.length), (_, idx) => idx + 1).map(cup => (
          React.createElement(Icon, {
            className: cup <= cups ? 'slider--detail-list-cup icon--cup-active' : 'slider--detail-list-cup',
            key: cup,
            src: `cup-${cup}`,
            onClick: () => cup <= quantities.length && onClick('cup', cup),
          })
        ))}
      </div>
      <input
        className="slider--detail-input"
        max={quantities.length}
        min="1"
        type="range"
        value={cups}
        onChange={(evt) => onChange(evt, 'cups')}
      />
    </div>
  </div>
);
